module.exports = __webpack_public_path__ + "static/media/filter.de3fd3ec.svg";